import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';

import { LoggedInCallback } from '../services/cognito.service';
import { UserLoginService } from '../services/user-login.service';

@Injectable()
export class ValidateUserGuard implements CanActivate {
  constructor(private router: Router, private userLoginService: UserLoginService) {}

  canActivate(): Promise<boolean> {
    return new Promise(resolve => {
      if (this.userLoginService.validationRequired === null) {
        this.router.navigate(['/login']);
      }

      resolve(this.userLoginService.validationRequired !== null);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/guards/validateuser.guard.ts